module.exports = __webpack_public_path__ + "img/login-banner.fd8b0a6e.png";